<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 341.4 341.4"
    style="enable-background: new 0 0 341.4 341.4"
    xml:space="preserve"
  >
    <g>
      <g>
        <polygon
          points="192,149.4 192,0 149.4,0 149.4,149.4 0,149.4 0,192 149.4,192 149.4,341.4 192,341.4 192,192 341.4,192
			341.4,149.4"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AppPlusIcon',
};
</script>
